import { authAPI } from '@/providers/apis/auth/auth';
import { sessionService } from '@/providers/services/auth/session';
import router from '@/routers/router';
import { Events } from '@/events';
import access from '@/permission/permission';

export class AuthService {
  private static INSTANCE = new AuthService();

  static get instance() {
    return this.INSTANCE;
  }

  public checkAuthentication() {
    const sessionModel = sessionService.getSession();
    const urlParams = new URLSearchParams(document.location.search);
    const nonceToken = urlParams.get('nonce');
    if (router.currentRoute.path !== '/share-url'
      && router.currentRoute.path !== '/facet-library'
      && !nonceToken && router.currentRoute.name !== 'guest'
    ) {
      if (sessionModel === null) {
        if (router.currentRoute.path !== '/login') {
          router.push('/login');
        }
      } else {
        this.validateToken();
      }
    } else {
      Events.$emit('onLoadedConfig');
    }
  }

  // Help to validate token while initial loading with existing session
  public validateToken() {
    const token = sessionService.getSession()!.access_token;
    if (token) {
      authAPI.signInWithToken(token);
    }

  }

  public async loginBasedOnAccessToken(query: any) {
    return access.loginBasedOnToken(query.access_token as any, query);
  }

}

export const authService = AuthService.instance;
